<ng-container *ngIf="inquiry$ | async as inquiry">
  <app-overlay-booking-details
    [readonly]="true"
    [showTimeZoneSource]="true"
    [inquiry]="inquiry"
  ></app-overlay-booking-details>
</ng-container>
